"use client";
import React from "react";
import { Tabs } from "antd";
import Image from "next/image";
import BasicSummary from "./tab-content/BasicSummary";
import Syllabus from "./tab-content/Syllabus";
import Routine from "./tab-content/Routine";
import Instructor from "./tab-content/Instructor";

export default function CourseDetailSection({ course }) {
  const items = [
    {
      key: "1",
      label: (
        <span className="course_tab_nav">
          <Image
            src="/images/course-img/at-a-glance.avif"
            alt="Price Tag"
            width={24}
            height={24}
          />
          এক নজরে
        </span>
      ),
      children: <BasicSummary course={course} />,
    },
    {
      key: "2",
      label: (
        <span className="course_tab_nav">
          <Image
            src="/images/course-img/syllabus.avif"
            alt="Price Tag"
            width={24}
            height={24}
          />
          কোর্স সিলেবাস
        </span>
      ),
      children: <Syllabus course={course} />,
    },
    {
      key: "3",
      label: (
        <span className="course_tab_nav">
          <Image
            src="/images/course-img/routine.avif"
            alt="Price Tag"
            width={24}
            height={24}
          />
          ক্লাস রুটিন
        </span>
      ),
      children: <Routine course={course} />,
    },
    {
      key: "4",
      label: (
        <span className="course_tab_nav">
          <Image
            src="/images/course-img/instructor.avif"
            alt="Price Tag"
            width={24}
            height={24}
          />
          ইনস্ট্রাক্টর
        </span>
      ),
      children: <Instructor course={course} />,
    },
  ];

  return (
    <div className="container">
      <div className="course-detail-tab-section section_short-padding">
        <div className="fa-card">
          <h2 className="details-main-title">
            <span>
              <Image
                src="/images/course-img/course-details.avif"
                alt="Price Tag"
                width={24}
                height={24}
              />
            </span>
            <span>কোর্স বিস্তারিত</span>
          </h2>
          <Tabs defaultActiveKey="1" items={items} className="course_tabs" />
        </div>
      </div>
    </div>
  );
}
